const { DISPLAY_SUBSCRIPTION_PRICE_USD } = require('./pricing');

/**
 * Single source of truth for the landing-page FAQ.
 *
 * Rendered as <details> accordions in app/components/landing/sections/bottom.js
 * AND emitted as FAQPage JSON-LD in app/page.js. Both consumers import THIS
 * array, so the visible copy and the structured data can never drift — Google
 * flags (and drops) FAQ rich results whose markup text doesn't match what the
 * page shows. Edit the copy here, once.
 *
 * The $5.99 figure interpolates DISPLAY_SUBSCRIPTION_PRICE_USD so the canonical
 * price stays in lockstep with the pricing card, OG image, and JSON-LD Offer.
 * The $2.99 Stream Suite tier is a literal (no constant exists for it yet — the
 * two-tier billing backend is a separate, not-yet-built task; today both plan
 * CTAs route to the single live $5.99 checkout).
 */
const LANDING_FAQ = [
  {
    q: 'Do I need the TTS plan?',
    a: `No. The $2.99 Stream Suite gives you alerts, donations, sounds, the links hub, and the command center. Add TTS + Voice Hold for $${DISPLAY_SUBSCRIPTION_PRICE_USD} whenever you want — same account, one click.`,
  },
  {
    q: 'Is Shoosh a StreamElements alternative?',
    a: 'Yes. Shoosh does alerts, donations, and OBS overlays across Twitch, YouTube, and TikTok — plus a live command center, Voice Hold, and chat FX that StreamElements never had. Setup takes about 5 minutes.',
  },
  {
    q: 'What is Voice Hold?',
    a: 'While you talk into your mic, TTS holds — chat messages queue up silently instead of playing over you. The moment you stop, it reads them back in order. No hotkeys, no manual muting — it just works, and no other stream TTS does it.',
  },
  {
    q: 'How do donations work?',
    a: 'Connect Stripe, share your tip page, and every tip pays straight to your bank — just 2.5% + 30¢, and donors can cover even that. Because Shoosh owns the audio, each tip reads itself aloud on stream automatically.',
  },
  {
    q: 'Do I need to install anything?',
    a: 'No. Shoosh runs in the cloud. You get a browser-source URL for OBS — paste it in and you’re done. Audio plays from your dashboard tab, which you route into your stream like any other desktop audio.',
  },
  {
    q: 'Can I use multiple platforms at once?',
    a: 'Yes. Connect Twitch, YouTube, and TikTok. All chat, alerts, and events flow into the same queue, overlay, and dashboard.',
  },
  {
    q: 'What happens after the free trial?',
    a: `Pick a plan — $2.99 or $${DISPLAY_SUBSCRIPTION_PRICE_USD}/mo — and add a card. Cancel anytime from the dashboard. No hoops, no emails, no guilt trip.`,
  },
];

module.exports = { LANDING_FAQ };
